6<template>
  <div class="family-card d-flex flex-column justify-content-between" :class="(descrizione.length > 12) ? 'nas' : ''" :id="code" @click="gotoFamilyLink(codice)">
    <div class="icona-testo">
      <img v-if="!imageError" :src="url('/media/icons/svg/family/white/' + code.toLowerCase() + '.svg')"
           @error="imageError = true"
           :alt="code + ' icon'">
      <img v-else style="filter: blur(4px)" :src="url('/media/icons/svg/family/white/C.svg')"
           :alt="code + ' icon'">
      <p>{{ descrizione }}</p>
    </div>

    <div class="selected-bar">

    </div>
  </div>
</template>

<script>
export default {
  name: "families",
  props: ['macro','codice', 'descrizione', 'active'],
  data() {
    return {
      imageError: false,
      code: this.codice,

    }
  },
  mounted() {
    this.parseFilename()
    this.isActive()

  },
  updated() {
    this.isActive()
  },
  watch: {
    active: function () {
      if (this.active) {

        $('#' + this.code +' .selected-bar').css('opacity', 1)
        $('#' + this.code +' p').css('color', '#fff')
        $('#' + this.code +'.family-card img').css({filter: "brightness(1)"})
        if (this.imageError){
          $('#' + this.code +'.family-card img').css({filter: "blur(4px)"})
        }
      } else {

        $('#' + this.code +' .selected-bar').css('opacity', 0)
        $('#' + this.code +' p').css('color', '#707070')
        $('#' + this.code +'.family-card img').css({filter: "brightness(.5)"})
        if (this.imageError){
          $('#' + this.code +'.family-card img').css({filter: "blur(4px)"})
        }
      }
    }
  },

  methods: {
    gotoFamilyLink: function (codfam) {
      window.location.replace(window.location.origin + (`/catalog/${this.macro}/family/${codfam}`));

    },
    isActive: function () {

        if (this.active){

        // console.log(this.code, $('#' + this.code).length)
          $('#' + this.code +' .selected-bar').css('opacity', 1)
          $('#' + this.code +' p').css('color', '#fff')
          $('#' + this.code +'.family-card img').css({filter: "brightness(1)"})

      }

    },
    emitActive: function () {
      this.$emit('active', this.codice)
    },
    parseFilename:  function () {
      this.code = this.code.replace(/\+/g, "plus")

    },
  },
}
</script>

<style lang="scss" scoped>
.family-card {
  cursor: pointer;
  width: 70px;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
 &.nas {
   height: 90%;
 }
 .icona-testo {
   display: flex;
   flex-direction: column;
   align-items: center;
 }
  img {
    width: 50px;

    filter: brightness(.5);
    &.active {
      filter: brightness(1);
    }
    @media (max-width: 576px){
      width: 45px;

    }
  }
  p {

    text-transform: lowercase;
    text-align: center;
    font-size: 16px;
    color: #707070 ;
    &:first-letter {
      text-transform: uppercase;
    }
    @media (max-width: 576px) {
      font-size: 14px;
    }
  }
  &:hover img {
    filter: brightness(1);
  }
  &:hover p {
    color: #fff;
  }
  &:hover .selected-bar {
     opacity: 1;
   }
  .selected-bar {
    margin-top: 2px;
    opacity: 0;
    background-color: var(--greenb2b);
    height: 3px;
    width: 100%;
  }
  @media (max-width: 576px){

  }
}
</style>
